import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { requireRoles } from '@/lib/middleware'
import { AdvancedShiftPage } from '@/features/shifts/pages/advanced-shift-page'

const searchSchema = z.object({
  clientId: z.string().optional(),
  startTime: z.string().optional(),
  endTime: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/shifts/new')({
  beforeLoad: async () =>
    requireRoles([
      'owner',
      'admin',
      'team_leader',
      'support_coordinator',
    ]),
  validateSearch: (search) => searchSchema.parse(search),
  component: AdvancedShiftPage,
})
